import React from 'react';
import RoomAdults from "../containers/RoomAdults";
import RoomsChildren from "../containers/RoomChildren";

const RoomComponent = ({index, room}) => {
  return (
      <div className="searchBarRoomBreakdownRow">
        <RoomAdults index={index} room={room} />
        <RoomsChildren index={index} room={room}/>
      </div>
  )
};

export default RoomComponent;



// WEBPACK FOOTER //
// ./src/components/RoomComponent.js